export const truncateText = (text: string, maxLength: number = 20) => {
    return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
};

/**
 * 获取可展开文本的显示内容
 * @param text 原始文本
 * @param isExpanded 是否已展开
 * @param maxLength 截断的最大长度
 * @returns 包含显示文本和是否需要截断的对象
 */
export const getExpandableText = (
    text: string,
    isExpanded: boolean,
    maxLength: number = 7
): { displayText: string; needsTruncate: boolean } => {
    const needsTruncate = text.length > maxLength;
    const displayText = needsTruncate && !isExpanded
        ? `${text.substring(0, maxLength)}...`
        : text;

    return { displayText, needsTruncate };
};

/**
 * 格式化包裹号：中间省略显示
 * @param trackingNumber 完整包裹号
 * @param prefixLength 保留开头字符数（默认 5）
 * @param suffixLength 保留结尾字符数（默认 4）
 * @returns 格式化后的包裹号，如 "SWX16****9552"
 */
export const formatTrackingNumberWithMiddleEllipsis = (
    trackingNumber: string,
    prefixLength: number = 5,
    suffixLength: number = 4
): string => {
    if (trackingNumber.length <= prefixLength + suffixLength) {
        return trackingNumber;
    }

    const prefix = trackingNumber.substring(0, prefixLength);
    const suffix = trackingNumber.substring(trackingNumber.length - suffixLength);

    return `${prefix}****${suffix}`;
};
